import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./modules/home/home.component').then((c) => c.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'registration',
    loadComponent: () =>
      import('./modules/login/components/registration/registration.component').then((c) => c.RegistrationComponent),
  },
  {
    path: 'change-password/:token',
    loadComponent: () =>
      import('./modules/reinit-password/reinit-password.component').then((c) => c.ReinitPasswordComponent),
  },
  {
    path: 'map',
    loadComponent: () => import('./modules/map/map.component').then((c) => c.MapComponent),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./modules/notifications/notifications.component').then((c) => c.NotificationsComponent),
  },
  {
    path: 'mobile-profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./modules/mobile-profile/mobile-profile.component').then((c) => c.MobileProfileComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () => import('./modules/admin/admin.routes').then((r) => r.routes),
  },
  {
    path: 'my',
    canActivate: [authGuard],
    loadChildren: () => import('./modules/my/my.routes').then((r) => r.routes),
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./modules/onboarding/onboarding.routes').then((r) => r.routes),
  },
  {
    path: 'contract-request',
    loadChildren: () => import('./modules/contract-request/contract-request.routes').then((r) => r.routes),
  },
];
